import { Directive, HostListener } from '@angular/core';
import { NavController } from 'ionic-angular';
import { GlobalsSingleton } from '../../app/core/GlobalsSingleton';
import { ChecklistPage } from '../../pages/checklist/checklist';
import { ChecklistPhonePage } from '../../pages/checklist/Phone/ChecklistPhonePage';


@Directive({
  selector: '[cklickHandler]' // Attribute selector
})
/**	=== Visionet(sl) ==========
 *	Behandelt den Klick auf einen LInk innerhalb von Zusatzinformationen, also innerhalb eines Fließtexts
 */
export class KlickAufChecklistenLinkHandler{


	/**	=== Visionet(sl) ==========
	 *	Den Konstruktor benötigen wir nur um den `NavController` zu erhalten
	 */
	constructor(public navCtrl: NavController, public globals: GlobalsSingleton) {
	}

	@HostListener('click', ['$event']) 
	public onClick(event) {
		if (event.target.tagName === 'A') {
			let checklisteId = event.target.getAttribute('data-checklisteId');
			if (checklisteId != undefined) {
				if (this.globals.isPhone()) {
					this.navCtrl.push(ChecklistPhonePage, {
						checklisteId: checklisteId.toString()
					},
					{
						animate : true,
						animation: "ios-transition"
					});
				}
				else {
					this.navCtrl.push(ChecklistPage, {
						checklisteId: checklisteId.toString()
					},
					{
						animate : true,
						animation: "ios-transition"
					});
				}
			}
		}
  	}

}



// WEBPACK FOOTER //
// ./src/directives/KlickAufChecklistenLinkHandler/KlickAufChecklistenLinkHandler.ts